export default __webpack_public_path__ + "f5ed262da08f732ca30eec475de0add5.png";